import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Tooltip,
} from '@material-ui/core';

import * as brandColors from '../../../utils/brand-colors';
import { formatDate } from '../../../utils/dateHelper';

class EventStateLabel extends React.Component {
  render() {
    const {
      completed,
      archived,
      dueDate,
    } = this.props;

    const currentDateTimestamp = new Date().getTime();
    const iconStyles = {
      fontSize: 18,
      marginRight: 4,
    };

    if (archived) {
      return (
        <Icon
          style={{
            ...iconStyles,
            color: brandColors.grey[300],
          }}
        >
          delete
        </Icon>
      );
    }

    if (completed) {
      return (
        <Icon
          style={{
            ...iconStyles,
            color: brandColors.primary.main,
          }}
        >
          check_circle
        </Icon>
      );
    }

    if (dueDate !== null && new Date(dueDate).getTime() < currentDateTimestamp) {
      return (
        <Tooltip title={`This event is past due: ${formatDate(dueDate)}`}>
          <Icon
            style={{
              ...iconStyles,
              color: brandColors.danger.main,
            }}
          >
            notification_important
          </Icon>
        </Tooltip>
      );
    }

    return '';
  }
}

EventStateLabel.propTypes = {
  completed: PropTypes.bool,
  archived: PropTypes.bool,
  dueDate: PropTypes.string,
};

EventStateLabel.defaultProps = {
  completed: false,
  archived: false,
  dueDate: null,
};

export default EventStateLabel;
